export default function Error({ message }) {
  return (
    <div
      style={{
        color: "red",
        marginLeft: "450px",
        marginTop: "20px",
      }}
    >
      {message}
    </div>
  );
}
